const KEY = 'bigcircle:last-login';

export function getLastLogin() {
  try {
    const value = JSON.parse(localStorage.getItem(KEY));
    return ['GOOGLE', 'FACEBOOK', 'PHONE', 'EMAIL'].includes(value?.method) ? value : null;
  } catch { return null; }
}

export function rememberLogin(method, phone = '') {
  try { localStorage.setItem(KEY, JSON.stringify({ method, phone: method === 'PHONE' ? phone : '' })); }
  catch { /* Sign-in still succeeds when browser storage is unavailable. */ }
}

const VISITED = 'bigcircle:auth-visited';
const NAME = 'bigcircle:auth-name';

export function rememberAuthName(name) {
  if (typeof name !== 'string' || !name.trim()) return;
  try { localStorage.setItem(NAME, name.trim().slice(0, 100)); }
  catch { /* Personalization is optional. */ }
}

export function markAuthVisit() {
  try { localStorage.setItem(VISITED, '1'); } catch { /* Browsing still works. */ }
}

export function getAuthGreeting(date = new Date()) {
  let name = '', visited = false;
  try {
    name = localStorage.getItem(NAME) || '';
    visited = localStorage.getItem(VISITED) === '1';
  } catch { /* Use a neutral greeting without storage. */ }
  if (name) {
    const hour = date.getHours();
    const greeting = hour < 12 ? 'Good morning' : hour < 18 ? 'Good afternoon' : 'Good evening';
    return `${greeting}, ${name}`;
  }
  return visited || getLastLogin() ? 'Welcome back' : 'Welcome';
}
